import { render, staticRenderFns } from "./UserActionsBox.vue?vue&type=template&id=d7e6d654"
import script from "./UserActionsBox.vue?vue&type=script&lang=js"
export * from "./UserActionsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports